import React from 'react'
import { Person } from '../../formParts/person'
import { ContactDetails } from '../../formParts/contactDetails'
import { AddressDetails } from '../../formParts/addressDetails'
import { ConfirmDetails } from '../../formParts/confirmDetails'
import { SignatureILSentinel } from '../../formParts/signatureILSentinel'
import styles from './styles.module.scss'
import shieldIcon from '../../../assets/shieldtick.svg'
import { OpenBankingLink } from '../../formParts/openBankingLink'

interface HeroSectionProps {
    formData: { [key: string]: string }
    currentSection: string
    showExpandedForm: boolean
    isTransitioningBack: boolean
    isAnimatingIn: boolean
    isFadingOutConfirm: boolean
    formRef: React.RefObject<HTMLDivElement>
    saveValueFunction: (data: { field: string; value: string }) => { success: boolean; error: string }
    assignGroup: (group: string) => void
    asyncAssignGroup: (group: string) => void
}

export const HeroSection: React.FC<HeroSectionProps> = ({
    formData,
    currentSection,
    showExpandedForm,
    isTransitioningBack,
    isAnimatingIn,
    isFadingOutConfirm,
    formRef,
    saveValueFunction,
    assignGroup,
    asyncAssignGroup,
}) => {
    return (
        <section
            style={{ paddingBottom: '80px' }}
            className={`${styles.heroSection} ${showExpandedForm ? styles.expandedMode : ''}`}
        >
            <div className={styles.heroContainer}>
                <div className={`${styles.heroContent} ${showExpandedForm ? styles.expandedMode : ''}`}>
                    <div
                        className={`${styles.heroLeft} ${showExpandedForm ? styles.hidden : ''} ${
                            isAnimatingIn ? styles.slideInLeft : ''
                        }`}
                    >
                        <h1 className={styles.heroTitle}>
                            Were You Sold Finance Products <span className={styles.highlight}>Irresponsibly?</span>
                        </h1>
                        <div className={styles.heroTaglines}>
                            <p className={styles.heroSubtitle}>
                                You could be entitled to compensation if your lender didn't properly assess your ability
                                to repay lending.
                            </p>
                            <ul className={styles.benefitsList}>
                                <li>Free initial assessment</li>
                                <li>No win, no fee guarantee</li>
                                <li>Expert legal representation</li>
                                <li>Thousands in potential compensation</li>
                            </ul>
                        </div>
                    </div>

                    <div className={`${styles.heroRight} ${showExpandedForm ? styles.fullWidth : ''}`}>
                        <div
                            ref={formRef}
                            className={`${styles.formContainer} ${showExpandedForm ? styles.expandedContainer : ''} ${
                                isTransitioningBack ? styles.transitioningBack : ''
                            } ${isFadingOutConfirm ? styles.fadingOutConfirm : ''} ${
                                isAnimatingIn ? styles.slideInRight : ''
                            }`}
                        >
                            <>
                                <div className={`${styles.formHeader} ${showExpandedForm ? styles.hidden : ''}`}>
                                    {currentSection === 'openBankingLink' ? (
                                        <h2 style={{ marginTop: 0 }}>Complete Your Application</h2>
                                    ) : (
                                        <>
                                            <h2 style={{ marginTop: 0 }}>Start Your Free Claim Assessment</h2>
                                            <p style={{ marginTop: '0' }}>
                                                Complete your details below to get started
                                            </p>{' '}
                                        </>
                                    )}
                                </div>
                                <div className={styles.formContent}>
                                    <AddressDetails
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={assignGroup}
                                        EnhancedLabelText="Lets begin by adding your current address, just type your postcode to get started."
                                    />
                                    <Person
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={assignGroup}
                                    />
                                    <ContactDetails
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={assignGroup}
                                    />
                                    <ConfirmDetails
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={asyncAssignGroup}
                                    />
                                    <SignatureILSentinel
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={assignGroup}
                                    />
                                    <OpenBankingLink
                                        saveValueFunct={saveValueFunction}
                                        isActive={currentSection}
                                        assignGroup={assignGroup}
                                    />
                                </div>

                                {/* Security Badge */}
                                <div className={styles.securityBadge}>
                                    <img src={shieldIcon} alt="Security Shield" className={styles.shieldIcon} />
                                    <div className={styles.securityText}>
                                        <span className={styles.secureText}>Secure Data Transfer</span>
                                        <span className={styles.sslText}>Protected by SSL encryption</span>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>

                    <div className={`${styles.heroBenefits} ${showExpandedForm ? styles.hidden : ''}`}>
                        <ul className={styles.benefitsList}>
                            <li>Free initial assessment</li>
                            <li>No win, no fee guarantee</li>
                            <li>Expert legal representation</li>
                            <li>Thousands in potential compensation</li>
                            {/* Duplicate content for seamless infinite scroll */}
                            <li>Free initial assessment</li>
                            <li>No win, no fee guarantee</li>
                            <li>Expert legal representation</li>
                            <li>Thousands in potential compensation</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}
